import { Checkbox, Form, FormInstance, Input, Space, Tooltip } from "antd";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { ZUid } from "src/types/zUid";
import { QuestionCircleOutlined } from "@ant-design/icons";
import styles from "../EditorInfo2.module.less";
import { edCompField, edItemField } from "../ParamsEditorInfo2";

type PropsMultipleChoiceIteratorDepend = {
  form: FormInstance;
};

export const MultipleChoiceIteratorDepend: React.FC<
  PropsMultipleChoiceIteratorDepend
> = ({ form }) => {
  const isIterator = Form.useWatch(edAttrField.iterator);
  const isCbvRuleExist = Form.useWatch(
    edItemField("copyByValueRule").concat("parentAttributeId"),
  );
  const multipleBlokers: ZUid[] | undefined = Form.useWatch(
    edCompField("multipleBlockers"),
  );
  const multipleBlocked = !!isCbvRuleExist || !!multipleBlokers?.length;

  React.useEffect(() => {
    if (isIterator) form.setFieldValue(edCompField("multiple"), true);
  }, [isIterator]);
  return (
    <Form.Item name={edCompField("multiple")} valuePropName="checked" noStyle>
      {/* Можественный выбор обязателен для итератора */}
      <Checkbox disabled={isIterator || multipleBlocked}>
        <Space>
          <span>Множественный выбор</span>
          {multipleBlocked && (
            <Tooltip
              title={
                <>
                  <div>
                    {isCbvRuleExist &&
                      "Ограничено атрибутом-источником в Копировании."}
                  </div>
                  <div>
                    {!!multipleBlokers?.length &&
                      `Ограничено целевыми атрибутами в Копировании: ${multipleBlokers.join(", ")}`}
                  </div>
                </>
              }
            >
              <QuestionCircleOutlined />
            </Tooltip>
          )}
        </Space>
      </Checkbox>
    </Form.Item>
  );
};
export const MaxCount: React.FC = () => (
  <Form.Item
    name={edCompField("maxCount")}
    label="Максимальное количество выбираемых элементов"
  >
    <InputNumberStd min={1} precision={0} />
  </Form.Item>
);
export const MaxSize: React.FC = () => (
  <Form.Item name={edCompField("maxSize")} label="Максимальный размер файлов">
    <InputNumberStd min={1} precision={0} addonAfter="Мб" />
  </Form.Item>
);
export const Precision: React.FC = () => (
  <Form.Item
    name={edCompField("precision")}
    label="Число знаков после запятой(точки)"
  >
    <InputNumberStd min={0} />
  </Form.Item>
);
export const Accept: React.FC = () => (
  <Form.Item
    name={edCompField("accept")}
    label="Фильтр на типы файлов"
    tooltip="Пример: .doc,.docx,application/msword"
  >
    <Input allowClear />
  </Form.Item>
);
export const Addon: React.FC = () => (
  <div className={styles.twoCols}>
    <Form.Item name={edCompField("addonBefore")} label="Префикс">
      <Input allowClear />
    </Form.Item>
    <Form.Item name={edCompField("addonAfter")} label="Суффикс">
      <Input allowClear />
    </Form.Item>
  </div>
);
